import React from 'react'
import { Container } from 'react-bootstrap'
import PropTypes from 'prop-types'


export const Loading = ( {isLoading = true, withText = true }, context) => {
        
    return (isLoading)?
        (
            <Container fluid>
                <br/>
                {/* <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {context.t('Loading...')}</h5>
                </div> */}
                {/* TODO: Cambiar por este nuevo estilo. Impacto: hay que modificar todos los lugares de la ECU que está hardcodeado */}
                <div className="d-flex align-items-center text-primary flex-column">
                    <div className="spinner-border" role="status" aria-hidden="true"></div>&nbsp;&nbsp;
                    {(withText)?(
                        <strong>{context.t('Loading...')}</strong>
                    ):(null)}
                </div>
            </Container>
        )
        :
        ("");
}

// PropTypes is necesary in order to obtain "context" in main function attribute.
Loading.contextTypes = {
    t: PropTypes.func
}

export default Loading;